"use client";
import { Checkbox, Typography } from "@repo/ui";
import Link from "next/link";
import { ComponentProps } from "react";

type TermsCheckboxProps = ComponentProps<typeof Checkbox>;

const TermsCheckbox = ({
  value,
  onCheckedChange,
  name,
  label,
  ...rest
}: TermsCheckboxProps) => {
  return (
    <Checkbox
      defaultChecked
      {...rest}
      label={
        label || (
          <Typography render={<span />}>
            I agree to Spoclearn{" "}
            <Typography
              render={<Link href="/terms-and-conditions/" />}
              color="primary"
              className="font-semi-bold"
            >
              terms of use{" "}
            </Typography>
            and privacy policy
          </Typography>
        )
      }
      onCheckedChange={onCheckedChange}
      name={name || "terms"}
      value={value}
    />
  );
};

export default TermsCheckbox;
